<template>
    <div class="setLoss_formation_box">
        <div class="inform_tit clear"> 
            <div @click="cancel" class='cancel_box' style="display:inline-block">
                <i class="el-icon-back myback_icon"></i> Back
            </div>
            <!--<span class="right_dateBox" v-if="time&&time!=null">Current FY&nbsp;: &nbsp;&nbsp;{{ time}}</span>-->
            <div class="date-top">Current FY： {{currentFy}}</div>
        </div>
        
        <template v-if="isPro">
           <div class="inMain_box">
            <div class="informdata_tit">Set Profit & Loss</div>
                <el-form style="width:740px;margin:0 auto" :model="ruleForm" label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                    <el-form-item label="P&L Data Cycle">
                        <ul class="month-choose clear">
                            <li :class="{'active': month === 1}" @click="changeMonth(1)">Last month<i v-if="getting && month === 1" class="el-icon-loading" style="margin-left:4px"></i></li>
                            <li :class="{'active': month === 3}" @click="changeMonth(3)">Last 3 months<i v-if="getting && month === 3" class="el-icon-loading" style="margin-left:4px"></i></li>
                            <li :class="{'active': month === 6}" @click="changeMonth(6)">Last 6 months<i v-if="getting && month === 6" class="el-icon-loading" style="margin-left:4px"></i></li>
                            <li :class="{'active': month === 12}" @click="changeMonth(12)">Last 12 months<i v-if="getting && month === 12" class="el-icon-loading" style="margin-left:4px"></i></li>
                        </ul>
                    </el-form-item>
                    <el-form-item label="Revenue" prop="Revenue">
                        <el-input v-model="ruleForm.Revenue" maxlength="10" 
                        @input="ruleForm.Revenue = ruleForm.Revenue.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                        @blur="updataTop(1)" class="venueInformation_input increaseInput">
                            <span slot="prefix" class="increaseIcon">$</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="Edit Expenses Method">
                        <div class="checkBox_list">
                            <div class="venue_checkBox">
                                <span v-if="ruleForm.does==0" @click="changeCheck(1)" class="venue_check"></span>
                                <span v-else class="venue_checked"></span>
                                <span class="venueCheckBox_msg" style="width:190px">Edit by subdata set</span>
                            </div>
                            <div class="venue_checkBox">
                                <span v-if="ruleForm.does==1"  @click="changeCheck(0)" class="venue_check"></span>
                                <span v-else class="venue_checked"></span>
                                <span class="venueCheckBox_msg" style="width:190px">Edit by total</span>
                            </div>
                        </div>
                        <!-- :data="ruleForm.does==1?tableData:tableDataByTotal" -->
                        <div style="margin-top:35px;padding-left:1px">
                            <el-table
                            :data="ruleForm.does==1?tableData:tableDataByTotal" 
                            border
                            class="venue_table_new"
                            style="width: 100%">
                                <el-table-column
                                prop="title"
                                align="center"
                                label-class-name="roster_th"
                                class-name="roster_row"
                                label="Operating Expenses">
                                    <template slot-scope="scope">
                                        <div style="word-break: break-word;">
                                            <span :style="{'color': scope.row.edited ? '#EA3796' : 'var(--text-color);'}">{{scope.row.title === 'total_c6cfa5efda5444888229aec4ece8df31' ? 'total': scope.row.title}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                align="center"
                                label-class-name="roster_th"
                                class-name="roster_row"
                                label="Cost">
                                    <template slot-scope="scope">
                                        <span :style="{'color': scope.row.edited ? '#EA3796' : 'var(--text-color);'}">{{scope.row.cost?(scope.row.cost>=0?`$${scope.row.cost}`:`-$${Math.abs(scope.row.cost)}`):'0.00'}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                align="center"
                                label-class-name="roster_th"
                                class-name="roster_row"
                                label="Percentage">
                                    <template slot-scope="scope">
                                        <span :style="{'color': scope.row.edited ? '#EA3796' : 'var(--text-color);'}">{{scope.row.percentage?scope.row.percentage:'0.00'}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                prop="address"
                                align="center"
                                label-class-name="roster_th"
                                class-name="roster_row"
                                label="">
                                    <template slot-scope="scope">
                                        <span v-if="!(ruleForm.does === 1 && scope.row.title === 'Total')" style="font-size:18px;cursor:pointer;color:#EA3796" @click="editDioOpen(scope.$index,scope.row)">Edit</span>
                                        <span v-if="(scope.row.title !== 'Total'&&scope.$index!==0)" @click="deleteItem(scope.row)" class="del-text">Delete</span>
                                    </template>
                                </el-table-column>
                                <template slot="empty">
                                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                                    <div v-else>No Data</div>
                                </template>
                            </el-table>
                            <div class="addnew_expenses" v-if="ruleForm.does==1" @click="addNewFee=true">
                                <span class="boldIcon">+</span>
                                <span>Add a New Expenses</span>
                            </div>
                        </div>
                    </el-form-item>

                    <div class="remove-title" v-if="removeData.length > 0">Items Removed</div>
                    <div style="padding-left:1px" v-if="removeData.length > 0">
                        <el-table
                        :data="removeData" 
                        border
                        class="venue_table_new hide_head"
                        style="width: 100%">
                            <el-table-column
                            prop="title"
                            align="center"
                            label-class-name="roster_th"
                            class-name="roster_row"
                            label="Operating Expenses">
                                <template slot-scope="scope">
                                    <div style="word-break: break-word;">
                                        <span style="color:#8A8D93">{{scope.row.title === 'total_c6cfa5efda5444888229aec4ece8df31' ? 'total': scope.row.title}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            align="center"
                            label-class-name="roster_th"
                            class-name="roster_row"
                            label="Cost">
                                <template slot-scope="scope">-</template>
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            align="center"
                            label-class-name="roster_th"
                            class-name="roster_row"
                            label="Percentage">
                                <template slot-scope="scope">-</template>
                            </el-table-column>
                            <el-table-column
                            prop="address"
                            align="center"
                            label-class-name="roster_th"
                            class-name="roster_row"
                            label="">
                                <template slot-scope="scope">
                                    <span @click="recoverItem(scope.row)" class="recover-text">Recover</span>
                                </template>
                            </el-table-column>
                            <template slot="empty">
                                <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                                <div v-else>No Data</div>
                            </template>
                        </el-table>
                    </div>


                    <el-form-item class="foot_box_new">
                        <el-button @click="updataInfo" class="ConBtn">Update P&L</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </template>

        <template v-if="isDoneLoad && !isPro">
            <div class="error-container d-flex align-items-center justify-content-center">
                <card-unauthorized></card-unauthorized>
            </div>
        </template>
        
        <el-dialog
        :title="ruleForm.does==1?'Edit Bank Fees':'Edit Total Operating Expenses'"
        :visible.sync="editFeeDio"
        :modal-append-to-body="false"
        :show-close='false'
        class="editCardDio"
        :close-on-click-modal='false'
        width="840px"
        center>
            <div>
                <div class="tag_tit">Cost</div>
                <el-input v-model="cost" @input="cost = cost.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" maxlength="12" @blur="blurCost" class="borderNone">
					<span slot="prefix" class="increaseIcon_new">$</span>
				</el-input>
                <div class="tag_tit">Percentage</div>
                <el-input v-model="Percentage" @input="Percentage = Percentage.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" @blur="blurPercentage" maxlength="12" class="borderNone">
					<span slot="suffix" class="increaseIcon_new">%</span>
				</el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editFeeDio = false,cost='',Percentage=''" class="cardCanBtn">Cancel</el-button>
                <el-button @click="editConfirm(2)" class="cardConBtn">Confirm<i v-if="requesting" class="el-icon-loading" style="margin-left:10px"></i></el-button>
            </span>
        </el-dialog>

        <el-dialog
        title="Add a New Expense"
        :visible.sync="addNewFee"
        :modal-append-to-body="false"
        :show-close='false'
        class="editCardDio"
        :close-on-click-modal='false'
        width="840px"
        center>
            <div>
                <div class="tag_tit">Expense Name</div>
                <el-input v-model="expenseName" maxlength="30" @blur="blurCost" class="borderNone"></el-input>
                <div class="flex-form">
                    <div class="item_new">
                        <div class="tag_tit">Cost</div>
                        <el-input v-model="cost" @input="cost = cost.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" maxlength="12" @blur="blurCost" class="borderNone">
                            <span slot="prefix" class="increaseIcon_new">$</span>
                        </el-input>
                    </div>
                    <div class="item_new">
                        <div class="tag_tit">Percentage</div>
                        <el-input v-model="Percentage" @input="Percentage = Percentage.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" @blur="blurPercentage" maxlength="12" class="borderNone">
                            <span slot="suffix" class="increaseIcon_new">%</span>
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addNewFee = false,cost='',Percentage='',expenseName=''" class="cardCanBtn">Cancel</el-button>
                <el-button @click="editConfirm(1)" class="cardConBtn">Confirm<i v-if="requesting" class="el-icon-loading" style="margin-left:10px"></i></el-button>
            </span>
        </el-dialog>

        <el-dialog
        title=""
        :visible.sync="updataDiolog"
        :modal-append-to-body="false"
        :show-close='false'
        class="delEmployDio"
        :close-on-click-modal='false'
        width="840px"
        center>
            <div class="rediolog_content">
                After the update, the P&L data in {{this.xeroFlag ? 'Xero ' : ''}}{{this.blueFlag ? 'Bluesheets ' : ''}}will be used instead. <br/> 
                Are you sure you want to continue?
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updataDiolog = false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="delDioConfirm" class="cardConBtn">Confirm<i v-if="requesting" class="el-icon-loading" style="margin-left:10px"></i></el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>
    </div>
</template>

<script>
import api from '../../api/api'
import cardUnauthorized from '@/components/card/unauthorized';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
export default {
    data() {
        return {
            month: 0,
            currentFy: '',

            time:'',
            updataDiolog:false,
            editFeeDio:false,
            addNewFee:false,
            cost:'',
            Percentage:"",
            expenseName:'',
            index:0,
            msg:'',
            loading:false,
            xeroFlag:false,
            blueFlag: false,
            rules:{
                Revenue:[{ required: true, message: ' ', trigger: 'blur' }],
            },
            ruleForm:{
				Revenue:'',
				does:1, //单选框默认选中
            },
            tableData:[],
            tableDataByTotal:[],

            requesting: false,

            getting: false,

            removeData: [],
            isPro: false,
            isDoneLoad: false,
            venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
        }
    },
    components: {
        cardUnauthorized: cardUnauthorized,
        freeTrialNotice: freeTrialNotice
    },
    methods: {
        changeCheck(type) {
            if (this.requesting)
                return
            this.ruleForm.does = type
            this.updataTop()
        },
        changeMonth(type) {
            if (this.getting)
                return
            this.month = type
            this.updataTop(2, type)
        },
        
        blurPercentage(){
            if(Number(this.ruleForm.Revenue)!=0&&Number(this.Percentage)!=0){
                let num = (Number(this.ruleForm.Revenue)!=0&&Number(this.Percentage)!=0)?Number(this.ruleForm.Revenue*(this.Percentage/100)).toFixed(2):0
                this.cost = num
            }
        },
        blurCost(){
            let num = (Number(this.ruleForm.Revenue)!=0&&Number(this.cost)!=0)?Number(this.cost/this.ruleForm.Revenue*100).toFixed(2):0
            this.Percentage = num
        },
        updataInfo(){
            if(this.xeroFlag || this.blueFlag){
                this.updataDiolog=true
            }else{
                Utils.alert('','No accounting account is currently bound.','error')
            }
        },
        cancel(){
            this.$router.push({path:'/setting'})
        },
        deleteItem(val){
            api.delProfitLossNew({title:val.title},res=>{
                const {code,data,message}=res.data;
                if(code==0){
                    this.getdetail()
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        recoverItem(val){
            api.recoveryApi({title:val.title},res=>{
                const {code,data,message}=res.data;
                if(code==0){
                    this.getdetail()
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        delDioConfirm(){
            this.requesting = true
            api.delProfitLoss({},res=>{
                this.requesting = false
                let {code,data,message}=res.data;
                this.updataDiolog = false
                if(code==0){
                    this.getdetail()
                    Utils.alert('','Success','success')
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        editDioOpen(index,msg){
            this.editFeeDio=true
            this.index=index
            this.msg=msg
            this.cost = msg.cost
            this.Percentage=msg.percentage
            // this.title=msg.title
        },
        editConfirm(key){
            if (this.requesting)
                return
            if(this.expenseName.toString()==''&&key===1){
                Utils.alert('','Please enter Expense Name','error')
                return
            }
            if(this.cost.toString()==''){
                Utils.alert('','Please enter cost','error')
                return
            }
            if(this.Percentage.toString()==''){
                Utils.alert('','Please enter percentage','error')
                return
            }
            if(key === 2){ // 修改
                if(this.ruleForm.does==1){
                    this.$set(this.tableData[this.index], `cost`, this.cost)
                    this.$set(this.tableData[this.index], `percentage`, this.Percentage)
                }else{
                    this.$set(this.tableDataByTotal[this.index], `cost`, this.cost)
                    this.$set(this.tableDataByTotal[this.index], `percentage`, this.Percentage)
                }
                const pat = {
                    title:this.ruleForm.does==1?this.tableData[this.index].title:this.tableDataByTotal[this.index].title,
                    value:this.cost
                }
                if (pat.title === 'Total')
                    pat.title = 'total_c6cfa5efda5444888229aec4ece8df31'
                this.requesting = true
                api.editProfitLoss(pat,res=>{
                    this.requesting = false
                    let {code,data,message}=res.data;
                    this.editFeeDio = false
                    this.expenseName = ''
                    this.cost = ''
                    this.Percentage = ''
                    if(code==0){
                        // this.getdetail()
                        this.opeationCallback(res)
                    }else{
                        Utils.alert('',message,'error')
                    }
                })
                return
            }
            // 添加、
            const pat = {
                title:this.expenseName,
                value:this.cost
            }
            api.addProfitLoss(pat,res=>{
                let {code,data,message}=res.data;
                this.addNewFee = false
                this.expenseName = ''
                this.cost = ''
                this.Percentage = ''
                if(code==0){
                    // this.getdetail()
                    this.opeationCallback(res)
                }else{
                    Utils.alert2('',message,'error')
                }
            })
        },
        updataTop(key, month){ // 切换分类
            if(this.ruleForm.Revenue.toString()==''){
                Utils.alert('','Please enter Revenue','error')
                return
            }
            const pat = {}
            if (key === 1) {
                pat.title = 'revenue_4fa38b609b6f469994bad8961bf73c53'
                pat.value = this.ruleForm.Revenue
            } else if (key === 2) {
                pat.title = 'dateCycle_272c3c8af71142129f784691160742ce'
                pat.value = month
            } else {
                pat.title = 'type_304197c884f04fe5b2fe15cdfe07314c'
                pat.value = this.ruleForm.does==1?1:2
            }
            this.getting = true
            api.editProfitLoss(pat,res=>{
                this.getting = false
                let {code,data,message}=res.data;
                this.editFeeDio = false
                if(code==0){
                    this.opeationCallback(res)
                    // this.ruleForm.Revenue = Number(this.ruleForm.Revenue).toFixed(2) 
                    // Utils.alert('','Success','success')
                }else{
                    Utils.alert('',message,'error')
                }
            })
            
        },
        getdetail(){
            this.loading = true
            this.tableDataByTotal = []
            this.tableData = []
            api.getProfitLossList('',res=>{
                let {code,data,message}=res.data;
                this.loading = false
                if(code==0){
                if(data==null)
                    {
                        this.currentFy = ''
                        this.ruleForm.Revenue = this.ruleForm.does==1?'0.00':'0.00'
                        this.tableDataByTotal = [{title:'Total',cost:'0.00',percentage:'0.00'}]
                        return
                    }
                    this.currentFy = data.currentFy
                    this.month = data.dateCycle_272c3c8af71142129f784691160742ce
                    this.ruleForm.does=data.type_304197c884f04fe5b2fe15cdfe07314c=='1'?1:0
                    this.ruleForm.Revenue = Number(data.revenue_4fa38b609b6f469994bad8961bf73c53).toFixed(2)
                    this.time = data.currentFy
                    this.tableData = data.subdata && data.subdata[0] !== null ? data.subdata : []
                    this.removeData = data.removedItem
                    this.tableData.forEach(v=>{
                        v.cost =Number(v.cost).toFixed(2)
                        v.percentage = Number(v.percentage).toFixed(2)
                    })
                    if(data.total_c6cfa5efda5444888229aec4ece8df31.length){
                        this.tableDataByTotal = data.total_c6cfa5efda5444888229aec4ece8df31
                        this.tableDataByTotal.forEach(v=>{
                            v.cost =Number(v.cost).toFixed(2)
                            v.percentage = Number(v.percentage).toFixed(2)
                        })
                    }
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        opeationCallback(res){
            let {code,data,message}=res.data;
            if(code==0){
                if(data==null){
                    this.ruleForm.Revenue = this.ruleForm.does==1?'0.00':'0.00'
                    this.tableDataByTotal = [{title:'Total',cost:'0.00',percentage:'0.00'}]
                    return
                }
                this.ruleForm.does=data.type_304197c884f04fe5b2fe15cdfe07314c=='1'?1:0
                this.currentFy = data.currentFy
                this.month = data.dateCycle_272c3c8af71142129f784691160742ce
                this.ruleForm.Revenue = Number(data.revenue_4fa38b609b6f469994bad8961bf73c53).toFixed(2)
                this.time = data.currentFy
                this.tableData = data.subdata && data.subdata[0] !== null ? data.subdata : []
                this.removeData = data.removedItem
                this.tableData.forEach(v=>{
                    v.cost =Number(v.cost).toFixed(2)
                    v.percentage = Number(v.percentage).toFixed(2)
                })
                if(data.total_c6cfa5efda5444888229aec4ece8df31.length){
                    this.tableDataByTotal = data.total_c6cfa5efda5444888229aec4ece8df31
                    this.tableDataByTotal.forEach(v=>{
                        v.cost =Number(v.cost).toFixed(2)
                        v.percentage = Number(v.percentage).toFixed(2)
                    })
                }
            }else{
                Utils.alert('',message,'error')
            }
        },
        closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}

    },
    mounted() {
        // this.getdetail()
        this.loading = true
        this.tableDataByTotal = []
        this.tableData = []
        api.getProfitLossList('',res=>{
            let {code,data,message}=res.data;
            this.loading = false
            if(code==0){
                if(data==null){
                    this.ruleForm.Revenue = this.ruleForm.does==1?'0.00':'0.00'
                    this.tableDataByTotal = [{title:'Total',cost:'0.00',percentage:'0.00'}]
                    return
                }
                this.currentFy = data.currentFy
                this.ruleForm.does=data.type_304197c884f04fe5b2fe15cdfe07314c=='1'?1:0
                this.ruleForm.Revenue = Number(data.revenue_4fa38b609b6f469994bad8961bf73c53).toFixed(2)
                this.month = data.dateCycle_272c3c8af71142129f784691160742ce
                this.time = data.currentFy
                this.tableData = data.subdata && data.subdata[0] !== null ? data.subdata : []
                this.removeData = data.removedItem
                this.tableData.forEach(v=>{
                    v.cost =Number(v.cost).toFixed(2)
                    v.percentage = Number(v.percentage).toFixed(2)
                })
                if(data.total_c6cfa5efda5444888229aec4ece8df31.length){
                    this.tableDataByTotal = data.total_c6cfa5efda5444888229aec4ece8df31
                    this.tableDataByTotal.forEach(v=>{
                        v.cost =Number(v.cost).toFixed(2)
                        v.percentage = Number(v.percentage).toFixed(2)
                    })
                }
            }else{
                Utils.alert('',message,'error')
            }
        })
        // this.xeroFlag=window.sessionStorage.getItem('xeroFlag');
        api.progress('',res=>{
            if(res.data.code==0){
                this.xeroFlag = res.data.data.xeroFlag
                this.blueFlag = res.data.data.blueesheetFlag

                // this.xeroVisibility = (res.data.data.trackingCategoriesFlag === false && res.data.data.xeroFlag === true) ? true : false
                this.xeroName = res.data.data.xeroTenantName === null || res.data.data.xeroTenantName === '' ? 'Xero' : res.data.data.xeroTenantName
                
                if (res.data.data.posInfo) {
                    this.posInfo = res.data.data.posInfo
                    this.posId = res.data.data.posInfo.posId
                }
                window.sessionStorage.setItem('deputyFlag',this.deputyFlag);
                window.sessionStorage.setItem('xeroFlag',this.xeroFlag);
            } else{
                Utils.alert('', res.data.message, 'error')
            }
        })

        this.$root.$on('isPro', (isPro, others) => { 
			this.isPro = isPro
			this.isDoneLoad = true

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
		})

    },
    computed: {
        Revenue(){
            return this.ruleForm.Revenue
        }
    },
    watch: {
        /*cost(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.cost = o;
					}, 100);
				}
			}
		},
        Percentage(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.Percentage = o;
					}, 100);
				}
                // if(n>100){
                //     this.Percentage = o
                // }
			}
		},
        Revenue(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(Number(n)) == false) {
					setTimeout(() => {
					    this.ruleForm.Revenue = o;
					}, 50);
				}
			}
		}*/
    },
}
</script>

<style lang="scss">
@font-face {
	font-family: Poppins-Regular;
	src: url('../../../static/fonts/Poppins-Regular.ttf');
}
.remove-title{
    padding-top: 40px;
    margin-bottom: 16px;
    font-size: 14px;
    font-family: SF Pro Text-Regular, SF Pro Text;
    font-weight: 400;
    color: var(--text-color);
    line-height: 16px;
}
.month-choose{
    li{
        width: 166px;
        height: 50px;
        background: var(--background-color-3);
        border-radius: 4px;
        border: 1px solid #5F5F5F;
        box-sizing: border-box;
        cursor: pointer;
        margin-right: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 15px;
        font-family: Poppins-Regular;
        font-weight: 400;
        color: var(--text-color);
        float: left;
        &:nth-last-child(1){
            margin-right: 0;
        }
    }
    .active{
        background: #EA3796;
        border-color: #EA3796;
    }
}
.date-top{
    font-size: 14px;
    font-family: SF Pro Text-Semibold, SF Pro Text;
    font-weight: 600;
    color: var(--text-color);
    line-height: 20px;
    float: right;
}
    .setLoss_formation_box{
        position: relative;
        .inform_tit{
            height:76px;
            font-size:14px;
            font-weight:600;
            color:var(--text-color);
            line-height:20px;
            width: 100%;
            background-color: var(--background-color);
            z-index: 100;
            .cancel_box{
                cursor: pointer;
                width: 150px;
            }
        }
        .inMain_box{
            background-color: var(--background-color-4);
            width: 100%;
            box-sizing: border-box;
            padding:50px 15%;
            margin-bottom: 40px;
            .informdata_tit{
                text-align: center;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:var(--text-color);
                line-height:42px;
            }
            .checkBox_list{
                display: flex;
                height: 40px;
                align-items: center;
            }
            .venue_checkBox{
                display: flex;
                align-items: center;
                margin-right: 319px;
                .venue_check{
                    width:16px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:16px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    width: 100px;
                    height:28px;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:var(--text-color);
                    line-height:28px;
                }
            }
            .venue_checkBox1{
                display: flex;
                align-items: center;
				margin-right: 30px;
                width: 100%;
                .venue_check{
                    width:17px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:17px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    height:28px;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:var(--text-color);
                    line-height:28px;
                }
            }
            .venueAddtype_btn{
                width:150px;
                height:40px;
                padding: 10px 20px !important;
                background:rgba(43,52,68,1);
                border:1px solid rgba(209,58,144,1);
                font-size:20px;
                font-weight:400;
                color:rgba(209,58,144,1);
            }
            .venueType_box{
                display: inline-block;
                padding:0 20px;
                height:40px;
                line-height: 40px;
                background:rgba(21,28,39,1);
                border:1px solid rgba(95,95,95,1);
                font-size: 20px;
                color: var(--text-color);
                vertical-align: top;
                box-sizing: border-box;
                margin-left: 30px;
                position: relative;
                border-radius: 4px;
                .myclose_icon{
                    position: absolute;
                    top: -12px;
                    right: -12px;
                    background-color: var(--text-color);
                    color: var(--background-color-4);
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 20px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
    .checked{
        color: #D13A90 !important;
	}
    .right_dateBox{
        float: right;
    }
	.increaseIcon{
		line-height: 50px;
		font-size: 18px;
		color: var(--text-color);
		&:first-child{
			margin-right: 20px;
		}
		&:last-child{
			margin-left: 20px;
		}
	}
    .rediolog_content{
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        color: var(--text-color);
        line-height: 33px;
    }
    .tag_tit{
		height:16px;
		font-size:14px;
		font-weight:400;
		color:var(--text-color);
		line-height:16px;
		margin: 30px 0 10px 0;
	}
    .increaseIcon_new{
        font-size: 22px;
        line-height: 50px;
        margin-left: 5px;
    }
    .addnew_expenses{
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        width: 100%;
        height: 60px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        // line-height: 60px;
        text-align:center;
        background-color: var(--background-color-3);
        border: 2px solid #5F5F5F;
        border-top: 1px solid #5F5F5F;
    }
    .boldIcon{
        font-size:30px;
        margin-right:12px;
        margin-top:-5px;
    }
    .del-text{
        width: 54px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4E4E;
        line-height: 25px;
        margin-left:20px;
        cursor:pointer;
    }
    .recover-text{
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #EA3796;
        line-height: 25px;
        margin-left:20px;
        cursor:pointer;
    }
    .flex-form{
        display:flex;
        justify-content:space-between;
        align-items:center;
        .item_new{
            width:49%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/setting/setProfitLoss.vue